/*=============================
=           Popunder          =
=============================*/

var popunder = document.getElementById('popunder'),
	domain = window.location.hostname;

if (popunder && !popunder.classList.contains('minimize')) {
	popunder.querySelector('button').focus();
	adjustPopunderHeight(false);
} else {
	adjustPopunderHeight(true);
}

[].slice.call(document.querySelectorAll('#popunder, #popunder button, #popunder a, #popunder span')).forEach(function (button) {
	button.addEventListener('click', function (e) {
		if (e.target.tagName == 'BUTTON' || e.target.tagName == 'A' || this.tagName == 'SPAN' || !document.querySelector('#popunder > div').contains(e.target)) {
			if (popunder.classList.contains('minimize')) {
				popunder.classList.remove('minimize');
				Cookie.remove('popunder', { domain: domain });
				adjustPopunderHeight(false);
			} else {
				popunder.classList.add('minimize');
				Cookie.set('popunder', 'minimize', { expires: 3, domain: domain });
				adjustPopunderHeight(true);
			}
		}
	});
});

function adjustPopunderHeight(isMinimized) {
	if(window.innerWidth <= 768) {
		var containerElement = document.querySelector('.has-popunder #popunder.minimize > div span');
		var containerElement2 = document.querySelector('.has-popunder #popunder > div span');
		var el = document.querySelector('#popunder.minimize > div .container1 div:nth-child(2) h4:first-child');

		if(el && isMinimized && containerElement) {
			var bottomOfH4 = el.offsetTop + el.offsetHeight;

			containerElement.style.transform = 'translateY(calc(100% - ' + bottomOfH4 + 'px - 0.625rem))';
		} else if (containerElement2){
			containerElement2.style.transform = 'none';
		}
	}
}
